var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMarketingFlyerIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44.858,
    height: 43.204,
    viewBox: "0 0 44.858 43.204",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brochure",
    transform: "translate(0 -9.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M42.562,9.44H29.078a3.522,3.522,0,0,0-2.126.742l-9.861,7.825a2.191,2.191,0,0,1-1.311.457H2.3A2.3,2.3,0,0,0,0,20.76V50.347a2.3,2.3,0,0,0,2.3,2.3H15.78a3.432,3.432,0,0,0,2.127-.742l9.861-7.825a2.1,2.1,0,0,1,.574-.323.665.665,0,0,0,.43-.616V10.779a2.1,2.1,0,0,1,.307-.024H42.562a.984.984,0,0,1,.983.983V41.324a.984.984,0,0,1-.983.983H31.256a.657.657,0,1,0,0,1.314H42.562a2.3,2.3,0,0,0,2.3-2.3V11.737a2.3,2.3,0,0,0-2.3-2.3ZM2.3,51.33a.984.984,0,0,1-.983-.983V39.505a15.4,15.4,0,0,0,1.9.878A.688.688,0,0,0,4.058,40a.657.657,0,0,0-.379-.848,14.094,14.094,0,0,1-2.365-1.17V20.76a.984.984,0,0,1,.983-.983H15.78q.154,0,.307-.014V38.013a14.074,14.074,0,0,1-7.362,2.07,14.3,14.3,0,0,1-1.973-.137.657.657,0,1,0-.182,1.3,15.627,15.627,0,0,0,2.155.149,15.393,15.393,0,0,0,7.362-1.866V51.306a2.1,2.1,0,0,1-.307.024Zm15.1-.7V19.369a2.979,2.979,0,0,0,.506-.332l9.551-7.579V42.715a2.979,2.979,0,0,0-.506.332Z",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M55.154,202.4c.139.091.092.743.086.952a1.841,1.841,0,0,0,2.42,1.758,1.58,1.58,0,0,1,1.53,0,1.811,1.811,0,0,0,.608.1,1.857,1.857,0,0,0,1.813-1.863,1.58,1.58,0,0,1,.473-1.455,1.841,1.841,0,0,0-.925-2.845,1.579,1.579,0,0,1-1.238-.9,1.841,1.841,0,0,0-2.992,0,1.58,1.58,0,0,1-1.238.9,1.838,1.838,0,0,0-.924,2.845Zm.576-1.763a.5.5,0,0,1,.334-.325,2.678,2.678,0,0,0,1.951-1.417c.248-.243.444-.34.823,0a2.678,2.678,0,0,0,1.95,1.417c.308.161.461.317.255.783a2.688,2.688,0,0,0-.745,2.293c-.057.343-.159.536-.666.484a2.688,2.688,0,0,0-2.411,0c-.344.051-.559.014-.666-.484a2.688,2.688,0,0,0-.745-2.293A.5.5,0,0,1,55.73,200.634Z",
    transform: "translate(-49.637 -171.475)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M69.479,408.814h4.027a.657.657,0,1,0,0-1.314H69.479a.657.657,0,0,0,0,1.314Z",
    transform: "translate(-62.792 -363.184)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M49.117,438.8H39.908a.657.657,0,0,0,0,1.314h9.209a.657.657,0,0,0,0-1.314Z",
    transform: "translate(-35.812 -391.738)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M228.016,116l-4.918,3.9a.657.657,0,1,0,.817,1.029l4.918-3.9a.657.657,0,1,0-.817-1.029Z",
    transform: "translate(-203.324 -97.091)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M228.016,157.494l-4.918,3.9a.657.657,0,0,0,.817,1.029l4.918-3.9a.657.657,0,1,0-.817-1.029Z",
    transform: "translate(-203.324 -134.952)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M228.016,198.99l-4.918,3.9a.657.657,0,1,0,.817,1.029l4.918-3.9a.657.657,0,1,0-.817-1.029Z",
    transform: "translate(-203.324 -172.813)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M228.016,285.908l-4.918,3.9a.657.657,0,0,0,.817,1.029l4.918-3.9a.657.657,0,0,0-.817-1.029Z",
    transform: "translate(-203.324 -252.116)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M228.016,327.4l-4.918,3.9a.657.657,0,1,0,.817,1.029l4.918-3.9a.657.657,0,1,0-.817-1.029Z",
    transform: "translate(-203.324 -289.976)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M357.412,64.361h6.78a1.6,1.6,0,0,0,1.6-1.6V59.931a1.6,1.6,0,0,0-1.6-1.6h-6.78a1.6,1.6,0,0,0-1.6,1.6v2.833A1.6,1.6,0,0,0,357.412,64.361Zm-.283-4.43a.283.283,0,0,1,.283-.283h6.78a.283.283,0,0,1,.283.283v2.833a.283.283,0,0,1-.283.283h-6.78a.283.283,0,0,1-.283-.283Z",
    transform: "translate(-324.641 -44.61)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M355.815,153.16a1.6,1.6,0,0,0,1.6,1.6h6.78a1.6,1.6,0,0,0,1.6-1.6v-2.833a1.6,1.6,0,0,0-1.6-1.6h-6.78a1.6,1.6,0,0,0-1.6,1.6Zm1.314-2.833a.283.283,0,0,1,.283-.283h6.78a.283.283,0,0,1,.283.283v2.833a.283.283,0,0,1-.283.283h-6.78a.283.283,0,0,1-.283-.283Z",
    transform: "translate(-324.641 -127.086)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M363.958,263.958a.643.643,0,1,0,.643.643A.643.643,0,0,0,363.958,263.958Z",
    transform: "translate(-331.484 -232.219)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M404.472,263.8H399.59a.657.657,0,0,0,0,1.314h4.882a.657.657,0,0,0,0-1.314Z",
    transform: "translate(-363.981 -232.071)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M363.958,304.2a.643.643,0,1,0,.643.643A.643.643,0,0,0,363.958,304.2Z",
    transform: "translate(-331.484 -268.936)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M404.472,304.038H399.59a.657.657,0,0,0,0,1.314h4.882a.657.657,0,0,0,0-1.314Z",
    transform: "translate(-363.981 -268.787)",
    fill: "#009dd7"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketingFlyerIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marketing-flyer-icon.fabd1a68.svg";
export { ForwardRef as ReactComponent };